module.exports = __webpack_public_path__ + "img/abgc3.25d3c913.jpg";